

export class MediaUtils {
    
    static getMobileOs = () => {
        var userAgent = navigator.userAgent || navigator.vendor;
        let mobileOs = null
        if (/windows phone/i.test(userAgent)) {
            mobileOs = "Windows Phone";
        } else if (/android/i.test(userAgent)) {
            mobileOs = "Android";
        } else if (/iPad|iPhone|iPod/.test(userAgent) ) { //&& !window.MSStream) {
            mobileOs = "iOS";
        }
        //console.log('getMobileOs() userAgent=' + userAgent + ', os=' + mobileOs)
        return mobileOs;
    }

    static isMobileOs = () => {
        return MediaUtils.getMobileOs() != null
    }
}